import MicroModal from 'micromodal';
import { getLenisInstance } from '../core/scroll-manager.js';

let teamModalListenerAttached = false;
let teamClickHandler = null;

/**
 * Initialize delegated click listener for team listings to open the profile modal.
 */
export function initializeTeamModal() {
    if (teamModalListenerAttached) return;

    teamClickHandler = (event) => {
        // Allow user to use modifier keys to open in a new tab (Ctrl, Cmd, Shift, Alt, middle-click)
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        const trigger = event.target.closest('.team-listing a, [data-team-modal-trigger], .team-listing');
        if (!trigger) return;

        const card = trigger.closest('.team-listing');
        if (!card) return;

        const modal = document.getElementById('team-modal');
        if (!modal) return;

        const modalDataTemplate = card.querySelector('.team-listing__modal-data');
        if (!modalDataTemplate) return;

        event.preventDefault();
        event.stopPropagation();

        // Extract data from template
        const templateContent = modalDataTemplate.content || modalDataTemplate;
        const nameEl = templateContent.querySelector('.team-data__name');
        const posEl = templateContent.querySelector('.team-data__position');
        const imgWrap = templateContent.querySelector('.team-data__image');
        const bioEl = templateContent.querySelector('.team-data__bio');

        const modalName = modal.querySelector('.team-modal__name');
        const modalPos = modal.querySelector('.team-modal__position');
        const modalImg = modal.querySelector('.team-modal__image');
        const modalBio = modal.querySelector('.team-modal__bio');

        if (modalName) modalName.textContent = nameEl ? nameEl.textContent.trim() : '';
        if (modalPos) modalPos.textContent = posEl ? posEl.textContent.trim() : '';
        if (modalBio) modalBio.innerHTML = bioEl ? bioEl.innerHTML : '';

        if (modalImg) {
            if (imgWrap && imgWrap.querySelector('img')) {
                modalImg.innerHTML = imgWrap.innerHTML;
            } else {
                modalImg.innerHTML = '';
            }
        }

        // Show modal via MicroModal
        try {
            MicroModal.show('team-modal', {
                awaitOpenAnimation: true,
                awaitCloseAnimation: true,
                disableScroll: false,
                onShow: () => {
                    getLenisInstance()?.stop();
                },
                onClose: () => {
                    getLenisInstance()?.start();
                    if (trigger && typeof trigger.focus === 'function') {
                        trigger.focus();
                    }
                }
            });
        } catch (e) {
            console.error('Error showing team modal:', e);
        }
    };

    document.body.addEventListener('click', teamClickHandler, true);
    teamModalListenerAttached = true;
}

/**
 * Clean up team modal listeners.
 */
export function destroyTeamModal() {
    if (teamModalListenerAttached && teamClickHandler) {
        document.body.removeEventListener('click', teamClickHandler, true);
        teamClickHandler = null;
        teamModalListenerAttached = false;
    }
}
